// @flow

import React, { type Node } from 'react';

import { type LookAndFeelRootPropsPendingPayment } from '@tectonics/look-and-feel';
import { ContextProvider } from './context-provider';
import { useIncomingPayment, getPaymentType, getCountry } from '@tectonics/prs/incoming-payment';
import { ExchangeRate } from '../commons/exchange-rate/components';
import { SelectedInstalmentDisplay } from '../commons/instalments/components';
import { PendingPageContent } from './pending-page-content';
import { Sidebar } from '../commons/sidebar/components';
import { type Country } from '@tectonics/prs/country';

import {
  ArgentineCashPageContent,
  BoletoPageContent,
  SpeiPageContent,
  OxxoPageContent,
  PixPageContent,
  NequiPageContent,
  EfectyPageContent,
} from './payment-method';

export function PendingPaymentPage(props: LookAndFeelRootPropsPendingPayment): Node {
  return (
    <ContextProvider {...props}>
      <PaymentMethodPage />
      <ExchangeRate />
      <SelectedInstalmentDisplay />
      <Sidebar />
    </ContextProvider>
  );
}

function PaymentMethodPage(): Node {
  const incomingPayment = useIncomingPayment();
  const paymentType = getPaymentType(incomingPayment);
  const country = getCountry(incomingPayment);
  if(!paymentType)
    throw new Error('No Payment type loaded');

  switch(paymentType) {
    case 'boleto':
      return <BoletoPageContent/>;

    case 'cash':
      return getCashPage(country);

    case 'creditcard':
    case 'debitcard':
    case 'webpay':
    case 'multicaja':
    case 'sencillito':
    case 'servipag':
    case 'eft':
    case 'externalpayprovider':
      return <PendingPageContent/>;

    case 'ewallet':
      return getEwalletPage(country);

    case 'oxxo':
      return <OxxoPageContent />;

    case 'spei':
      return <SpeiPageContent />;

    case 'pix':
      return <PixPageContent />;

    default:
      throw new Error(`No pending page for payment type ${paymentType}`);
  }
}

function getEwalletPage(country: Country): Node {
  switch (country) {
    case 'co':
      return <NequiPageContent/>;
    default:
      return <PendingPageContent/>;
  }
}

function getCashPage(country: Country): Node {
  switch (country) {
    case 'ar':
      return <ArgentineCashPageContent/>;
    case 'co':
      return <EfectyPageContent/>;
    default:
      return <PendingPageContent/>;
  }
}
